import { render } from "./TimetablePage.vue?vue&type=template&id=6fd3c810&scoped=true"
import script from "./TimetablePage.vue?vue&type=script&lang=js"
export * from "./TimetablePage.vue?vue&type=script&lang=js"

import "./TimetablePage.vue?vue&type=style&index=0&id=6fd3c810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd3c810"]])

export default __exports__